import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import AppStorage from "@/utils/helpers";

/**
 * Order type enum
 */
export type OrderType = "delivery" | "pickup" | null;

interface CheckoutState {
  orderType: OrderType;
}

/**
 * Load order type from storage
 */
const loadOrderTypeFromAppStorage = (): OrderType => {
  if (typeof window !== "undefined") {
    const orderType = AppStorage.get("orderType");
    return orderType as OrderType;
  }
  return null;
};

/**
 * Save order type to storage
 */
const saveOrderTypeToAppStorage = (orderType: OrderType) => {
  if (orderType) {
    AppStorage.save("orderType", orderType);
  } else {
    AppStorage.remove("orderType");
  }
};

const initialState: CheckoutState = {
  orderType: loadOrderTypeFromAppStorage(),
};

/**
 * Checkout slice managing checkout process state
 */
const checkoutSlice = createSlice({
  name: "checkout",
  initialState,
  reducers: {
    setOrderType: (state, action: PayloadAction<OrderType>) => {
      state.orderType = action.payload;
      saveOrderTypeToAppStorage(action.payload);
    },
    clearCheckout: (state) => {
      state.orderType = null;
      AppStorage.remove("orderType");
    },
  },
});

export const { setOrderType, clearCheckout } = checkoutSlice.actions;

// Selectors
export const selectOrderType = (state: { checkout: CheckoutState }) =>
  state.checkout.orderType;

export default checkoutSlice.reducer;
